import { createContext, useContext, useRef, useCallback, useSyncExternalStore, useEffect } from "react";
import _ from "lodash";

const createStore = (initialState) => {
  let state = initialState;
  const listeners = new Set();

  return {
    getState: () => state,
    setState: (nextState) => {
      if (!_.isEqual(state, nextState)) {
        state = nextState;
        listeners.forEach((l) => l());
      }
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    }
  };
};

const DetailDataContext = createContext(null);

export const DetailDataProvider = ({ children, state }) => {
  const storeRef = useRef(createStore(state));

  useEffect(() => {
    storeRef.current.setState(state);
  }, [state]);

  return (
    <DetailDataContext.Provider value={storeRef.current}>
      {children}
    </DetailDataContext.Provider>
  );
};



export const useDetailData = (field) => {
    const store = useContext(DetailDataContext);
    const lastSelectedRef = useRef();
    const hasValueRef = useRef(false);
  
    const subscribe = useCallback((cb) => store.subscribe(cb), [store]);
  
    const getSnapshot = useCallback(() => {
      const state = store.getState();
      const nextSelected = field ? _.get(state, field) : state;
  
      // HACK: skip render if only the reference changed but not the value
      if (hasValueRef.current && _.isEqual(lastSelectedRef.current, nextSelected)) {
        return lastSelectedRef.current;
      }
  
      hasValueRef.current = true;
      lastSelectedRef.current = nextSelected;
      return nextSelected;
    }, [store, field]);

    return useSyncExternalStore(subscribe, getSnapshot);
  };

export default DetailDataContext;